import React, { useRef, useState } from "react";
import { Select, Form } from "antd";
import { PageviewTwoTone } from "@material-ui/icons";

import searchEngineList from "./searchEngineList";
import InputStyles from "./styles/InputStyles";

const SearchEngineSelect = ({ classWidth = "" }) => {
  const searchEngineRef = useRef(null);
  const [activeInput, setActiveInput] = useState("");

  const searchEngineOptions = searchEngineList.map((searchEngine) => {
    return (
      <Select.Option value={searchEngine} key={searchEngine}>
        {searchEngine}
      </Select.Option>
    );
  });

  function handleChange(value) {
    searchEngineRef.current.blur();
  }

  return (
    <InputStyles>
      <Form.Item name="searchEngine" className={`mb-1 mr-0 ${classWidth}`}>
        <Select
          mode="multiple"
          placeholder={
            <>
              <PageviewTwoTone className="mr-2 inputIcon" /> Search Engine
            </>
          }
          allowClear
          ref={searchEngineRef}
          onChange={handleChange}
          className={`select ${classWidth} ${
            activeInput === "searchEngine" && "activeSelect"
          }`}
          onFocus={() => {
            setActiveInput("searchEngine");
          }}
          onBlur={() => setActiveInput("")}
        >
          {searchEngineOptions}
        </Select>
      </Form.Item>
    </InputStyles>
  );
};

export default SearchEngineSelect;
